// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const AbsentFormSingle = () => {
//   // Extracting absentformId using regular expressions
//   const location = useLocation();
//   // const absentformId = location.pathname.match(/\/class\/(\d+)/);
//   const absentformId = location.pathname.match(/\/absent-form\/(\d+)/)?.[1];

//   const [absentform, setAbsentform] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchClass = async () => {
//     try {
//       const response = await fetch(
//         `${serverUrl}/student/Aform/${absentformId}`
//       );
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch class');
//       // }
//       const data = await response.json();
//       setAbsentform(data);
//       localStorage.setItem("lformData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (absentformId) {
//       fetchClass();
//     }
//   }, [absentformId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">Absent Form Details</h1>
//                 <div className="item">
//                   Absent:
//                   <img
//                     src={absentform?.data.absent_file_url}
//                     alt=""
//                     className="itemImg"
//                   />
//                   <div className="details">
//                     <h1 className="itemTitle">
//                       {absentform?.data.student_names}
//                     </h1>
//                     {/* <div className="detailItem">
//                                             <span className="itemKey">Id: </span>
//                                             <span className="itemValue">{absentform?.data.id}</span>
//                                         </div> */}
//                     {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{absentform?.data.center_id}</span>
//                                         </div> */}
//                     <div className="detailItem">
//                       <span className="itemKey">Teacher: </span>
//                       <span className="itemValue">
//                         {absentform?.data.user_names}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Date: </span>
//                       <span className="itemValue">{absentform?.data.date}</span>
//                     </div>

//                     {/* <div className="detailItem">
//                                             <span className="itemKey">Time: </span>
//                                             <span className="itemValue">{absentform?.data.time}</span>
//                                         </div> */}
//                     <div className="detailItem">
//                       <span className="itemKey">Reason for Absent: </span>
//                       <span className="itemValue">
//                         {absentform?.data.reason}
//                       </span>
//                     </div>
//                     {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{absentform?.data.status}</span>
//                                         </div> */}
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="class Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default AbsentFormSingle;
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const AbsentFormSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const absentformId = location.pathname.match(/\/absent-form\/(\d+)/)?.[1];
  const [absentform, setAbsentform] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchClass = async () => {
    try {
      const response = await fetch(
        `${serverUrl}/student/Aform/${absentformId}`
      );
      const data = await response.json();
      setAbsentform(data);
      localStorage.setItem("lformData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (absentformId) {
      fetchClass();
    }
  }, [absentformId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Absent Form Details</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Header Section */}
                <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Student Avatar */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <span className="text-2xl md:text-3xl text-purple-600">
                          {absentform?.data.student_names
                            ?.charAt(0)
                            .toUpperCase()}
                        </span>
                      </div>
                    </div>

                    {/* Student Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {absentform?.data.student_names}
                      </h1>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        {absentform?.data.user_names && (
                          <div>
                            <span className="text-gray-500">Teacher:</span>
                            <span className="ml-2 font-medium">
                              {absentform.data.user_names}
                            </span>
                          </div>
                        )}
                        {absentform?.data.date && (
                          <div>
                            <span className="text-gray-500">Date:</span>
                            <span className="ml-2 font-medium">
                              {absentform.data.date}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Absent Details */}
                <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Absence Details
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Reason Section */}
                    {absentform?.data.reason && (
                      <div>
                        <h4 className="text-sm font-medium text-gray-500 mb-2">
                          Reason for Absence
                        </h4>
                        <div className="bg-gray-50 rounded-lg p-4 min-h-[100px]">
                          <p className="text-gray-800">
                            {absentform.data.reason}
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Document Section */}
                    <div>
                      <h4 className="text-sm font-medium text-gray-500 mb-2">
                        Supporting Document
                      </h4>
                      {absentform?.data.absent_file_url ? (
                        <div className="relative group">
                          <img
                            src={absentform.data.absent_file_url}
                            alt="Absent form document"
                            className="w-full h-48 object-contain border-2 border-gray-200 rounded-lg cursor-pointer hover:border-purple-300 transition-colors"
                            onLoad={() => setImageLoaded(true)}
                            onClick={() =>
                              window.open(
                                absentform.data.absent_file_url,
                                "_blank"
                              )
                            }
                          />
                          {!imageLoaded && (
                            <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-lg">
                              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-purple-500"></div>
                            </div>
                          )}
                          <div className="absolute bottom-2 right-2 bg-black bg-opacity-50 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            Click to view full size
                          </div>
                        </div>
                      ) : (
                        <div className="bg-gray-50 rounded-lg p-8 text-center text-gray-400">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-12 w-12 mx-auto mb-2"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            />
                          </svg>
                          No document attached
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Additional Information */}
                <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Additional Information
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                    {absentform?.data.id && (
                      <div>
                        <span className="text-gray-500 block mb-1">
                          Form ID:
                        </span>
                        <span className="font-medium">
                          {absentform.data.id}
                        </span>
                      </div>
                    )}
                    {absentform?.data.date && (
                      <div>
                        <span className="text-gray-500 block mb-1">
                          Submitted:
                        </span>
                        <span className="font-medium">
                          {absentform.data.date}
                        </span>
                      </div>
                    )}
                    {absentform?.data.time && (
                      <div>
                        <span className="text-gray-500 block mb-1">Time:</span>
                        <span className="font-medium">
                          {absentform.data.time}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AbsentFormSingle;
